// extracted by mini-css-extract-plugin
export var buttons = "GetStarted-module--buttons--bc7b0";
export var container = "GetStarted-module--container--9bab3";
export var content = "GetStarted-module--content--e4d28";
export var getStarted = "GetStarted-module--getStarted--e4a5c";
export var imageContainer = "GetStarted-module--imageContainer--60484";
export var mainContent = "GetStarted-module--mainContent--e33e1";
export var subHeading = "GetStarted-module--subHeading--d30e7";
export var textContent = "GetStarted-module--textContent--d7b5e";